import { normalizeCustomer } from '@utils/storeDataNormalization';
import { storeConstants } from '@utils/constants';
import { mutationTypes } from '@helpers/storeFactories/helpers';
import storeModuleFactory from '@helpers/storeModuleFactory';
import { apiService } from '@api';
import notificationUtils from '@/utils/notificationUtils';

const STORE_NAME = 'customers';

const store = storeModuleFactory.createModuleView(
    STORE_NAME,
    {
        get: apiService.customers.get,
    },
    {
        actionGetOptionsDefault: {
            refresh: false,
            offset: 0,
            limit: storeConstants.ITEMS_PER_PAGE,
        },
        mapListItemFn: normalizeCustomer,
    },
    {
        state: {
            selectedCustomer: null,
            filters: {},
        },
        getters: {
            filters: (state) => state.filters,
            total: (state) => state.totalCount,
            selectedCustomer: (state) => state.selectedCustomer,
        },
        mutations: {
            [mutationTypes.UPDATE_FILTERS](state, { filters }) {
                state.filters = filters;
            },
            [mutationTypes.UPDATE_ITEM](state, { id, data }) {
                const item = normalizeCustomer(data);
                const index = state.list.findIndex((item) => item.id === id);
                Object.assign(state.list[index], item);
            },
            setSelectedCustomer(state, customer) {
                state.selectedCustomer = customer;
            },
        },
        actions: {
            async updateFilters({ commit }, { filters }) {
                return commit(mutationTypes.UPDATE_FILTERS, { filters });
            },
            setSelectedCustomer({ commit }, customer) {
                commit('setSelectedCustomer', customer);
            },
            async update({ commit, dispatch }, { id, partnerId, payload }) {
                const response = await apiService.customers.update(id, partnerId, { ...payload });
                if (!response.success) {
                    dispatch('notification/error', notificationUtils.getFromApiResponse(response), {
                        root: true,
                    });

                    return response;
                } else {
                    const responseData = response.data;

                    commit(mutationTypes.UPDATE_ITEM, { id: responseData.id, data: responseData });

                    return {
                        success: true,
                        data: responseData,
                    };
                }
            },
        },
    }
);

export default store;
